import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { ijtaiOutcomes, ijtaiStats } from "@/mocks/ijtaiData";
import { Link } from "react-router-dom";

export default function IjtaiOutcomes() {
  return (
    <section className="bg-tie-navy py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-12 md:mb-16">
            {ijtaiStats.map((stat, index) => (
              <ScrollReveal key={stat.label} delay={index * 100}>
                <div className="p-5 md:p-6 rounded-xl bg-white/5 border border-white/10 text-center">
                  <p className="font-serif text-3xl md:text-4xl font-bold text-tie-teal-light">
                    {stat.value}
                  </p>
                  <p className="mt-1.5 text-sm font-semibold text-white/90">
                    {stat.label}
                  </p>
                  <p className="mt-0.5 text-xs text-white/50">
                    {stat.sub}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal>
            <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/20 mb-4 md:mb-6">
                <span className="text-xs font-semibold text-tie-teal-light uppercase tracking-wider">
                  / Value for Authors & Readers
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight">
                {ijtaiOutcomes.title}
              </h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {ijtaiOutcomes.items.map((item, index) => (
              <ScrollReveal key={item.title} delay={index * 100}>
                <div className="group h-full p-5 md:p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-tie-teal/30 transition-all duration-300">
                  <div className="flex items-center gap-3 mb-3 md:mb-4">
                    <div className="w-10 h-10 rounded-lg bg-tie-teal/20 flex items-center justify-center shrink-0">
                      <i className={`${item.icon} text-tie-teal-light text-base`} />
                    </div>
                    <h3 className="text-base md:text-lg font-semibold text-white">
                      {item.title}
                    </h3>
                  </div>
                  <p className="text-sm text-white/60 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal delay={300}>
            <div className="mt-10 md:mt-12 text-center">
              <Link
                to="/collaborate"
                className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-tie-teal text-white font-medium text-sm md:text-base hover:bg-tie-teal-dark transition-all duration-300 whitespace-nowrap"
              >
                Submit a Paper to IJTAI
                <i className="ri-arrow-right-line ml-2" />
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}